import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AppErrorComponent } from './app.error/app.error.component';
import { AppNotfoundComponent } from './app.notfound/app.notfound.component';
import { AppUnauthorizedComponent } from './app.unauthorized/app.unauthorized.component';
import { AppHeaderComponent } from './app.header/app.header.component';
import { AppMainComponent } from './app.main/app.main.component';
import { AppSidebarComponent } from './app.sidebar/app.sidebar.component';
import { AppNavbarComponent } from './app.navbar/app.navbar.component';
import { CaaksUserPanelComponent } from './caaks-userpanel/caaks-userpanel.component';
import { AlertDialogComponent } from '../shared/error/alert/alert-dialog.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AppHeaderComponent,
    AppSidebarComponent,
    AppNavbarComponent,
    AppErrorComponent,
    AppNotfoundComponent,
    AppUnauthorizedComponent,
    AppMainComponent,
    CaaksUserPanelComponent,
    AlertDialogComponent,
  ],
  imports: [SharedModule, RouterModule],
  exports: [],
})
export class AppLayoutModule {}
